import { Pipe, PipeTransform } from '@angular/core';
import { SharedDataService } from '../services/shared-data.service';

@Pipe({
  name: 'engieClientId2name'
})
export class EngieClientId2namePipe implements PipeTransform {

  constructor(private _sharedDataService: SharedDataService) { }

  transform(value: any, withId: boolean = false): string {
    let found = this._sharedDataService.clientParties.find(p => p.clientParty.mailStop === "" + value);
    return found ? found.partyName : "client-name-not-found";
  }

}
